import type { RouteRecordRaw } from 'vue-router'

export const studioRoutes: RouteRecordRaw[] = [
  {
    path: '/studio/select',
    name: 'studio-select',
    component: () => import('./views/StudioSelectView.vue'),
    meta: { requiresAuth: true },
  },
]
